$(document).ready(function() {
    $(document).on('click', '.search__buttons', function(e) {
     
        e.stopPropagation(); 
        var searchBar = $('.PwsSeacrinput');
        if (searchBar.css('display') === 'none') {
            searchBar.css('display', 'block');
            $('.PwsSearchForm').addClass('openSearchBar');
        } else {
            searchBar.css('display', 'none');
              $('.PwsSearchForm').removeClass('openSearchBar');
        }
    });
    $(document).on('click', '.PwsSeacrinput', function(e) {
        e.stopPropagation();

    });
    $(document).on('click', function() {
        $('.PwsSeacrinput').css('display', 'none');
        
    });
    

var $carousel = $('.carousel-main');
var $barDotsContainer = $('.slick-bar-dots');

$carousel.on('init', function(event, slick) {
  // create bars dynamically based on number of slides
  for (var i = 0; i < slick.slideCount; i++) {
    $barDotsContainer.append('<div class="bar-dot" data-slide="' + i + '"><span class="bar"></span></div>');
  }
  setActiveBar(0);
});

$carousel.on('afterChange', function(event, slick, currentSlide) {
  setActiveBar(currentSlide);
});

// click navigation
$barDotsContainer.on('click', '.bar-dot', function() {
  var slideIndex = $(this).data('slide');
  if ($.fn.slick) $carousel.slick('slickGoTo', slideIndex);
});

function setActiveBar(index) {
  $('.bar-dot').removeClass('active');
  $('.bar-dot').eq(index).addClass('active');
}

// slick.js is only loaded on product pages (theme.liquid); guard so the rest of
// this ready-block (global add-to-cart delegation below) survives elsewhere.
if ($carousel.length && typeof $.fn.slick === 'function')
$carousel.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  lazyLoad: 'ondemand',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});
    
  $(document).on('click','.Section_btn',function(){
    $('.drawer_section').addClass('clickBtn');
  });

  $(document).on('click','.drawer-close-btn',function(){
    // alert('close');
    $('.drawer_section').removeClass('clickBtn');
  });

  // Click a size on any product card -> add that variant to cart. Delegated on document so
  // it works for cards injected asynchronously too (Recently Viewed via Section Rendering
  // API, You May Also Like via recommendations) whose inline <script> never executes.
  $(document).off('click.addtocart', '.size-variant').on('click.addtocart', '.size-variant', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $btn = $(this);
    if ($btn.hasClass('unavailable') || $btn.attr('aria-disabled') === 'true') return;
    var variantId = $btn.attr('data-size-id');
    if (!variantId) return;
    if ($btn.hasClass('is-loading')) return;
    $btn.addClass('is-loading');
    $('.size-variant').removeClass('selected');
    $btn.addClass('selected');
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsParam = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-icon-bubble', 'cart-drawer', 'cart-live-region-text'];
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      contentType: 'application/json',
      data: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }], sections: sectionsParam, sections_url: window.location.pathname }),
      dataType: 'json',
      success: function (parsedState) {
        $btn.removeClass('is-loading');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          if (typeof cartDrawer.renderContents === 'function') { cartDrawer.renderContents(parsedState); }
          else if (typeof cartDrawer.open === 'function') { cartDrawer.open(); }
        }
      },
      error: function (err) { $btn.removeClass('is-loading'); console.log('Failed to add to cart', err); }
    });
  });

  $('.card-wrapper').each(function() {
    var card = $(this);
    var container = card.find('.PwsAppend_swatchimage');
    var regularPrice = card.find('.SingleRegular_Price');

    card.find('.PWscolor-swatch').hover(function() {
      var imgUrl = $(this).attr('data-product-image');
      var regularprice = $(this).attr('data-product-money');
      if(imgUrl) {
        container.append(
          '<img class="hover-swatch-img" src="' + imgUrl + '" style="position:absolute; top:0; left:0; width:100%; height:100%; object-fit:cover;" />'
        );
      }
      
    });

  });










  
});

document.addEventListener("DOMContentLoaded", function() {
  const desc = document.querySelector(".product__description");
  const btn = document.querySelector(".learn-more-btn");
  if (!desc || !btn) return;

  // Apply line-clamp first to measure the exact pixel height of N lines.
  // This becomes the "collapsed target" for the max-height animation later.
  desc.classList.add("is-collapsed");
  const collapsedHeight = desc.clientHeight;

  // If description already fits within collapsed height, hide the button entirely.
  if (desc.scrollHeight <= collapsedHeight + 1) {
    btn.style.display = "none";
    desc.classList.remove("is-collapsed");
    return;
  }

  // Static states are governed by .is-collapsed class (line-clamp, perfectly aligned).
  // The slide-in / slide-out transition uses max-height animation in between.
  desc.style.overflow = "hidden";
  desc.style.transition = "max-height 0.4s ease";

  let expanded = false;

  btn.addEventListener("click", function() {
    if (expanded) {
      // Expanded → Collapsed: anchor at current full height, then animate down.
      desc.style.maxHeight = desc.scrollHeight + "px";
      desc.offsetHeight; // force reflow so the next change triggers a transition
      desc.style.maxHeight = collapsedHeight + "px";
      btn.textContent = "Show more";
      btn.classList.remove("is-expanded");
      expanded = false;
      // After the slide-out finishes, snap to the clean line-clamp state and release inline maxHeight.
      const onEnd = function(e) {
        if (e.propertyName !== "max-height") return;
        desc.classList.add("is-collapsed");
        desc.style.maxHeight = "";
        desc.removeEventListener("transitionend", onEnd);
      };
      desc.addEventListener("transitionend", onEnd);
    } else {
      // Collapsed → Expanded: anchor at the clamped height, drop line-clamp, then animate up to full.
      desc.style.maxHeight = collapsedHeight + "px";
      desc.classList.remove("is-collapsed");
      desc.offsetHeight; // force reflow before transitioning to scrollHeight
      desc.style.maxHeight = desc.scrollHeight + "px";
      btn.textContent = "Show less";
      btn.classList.add("is-expanded");
      expanded = true;
      // After the slide-in finishes, drop the inline maxHeight so natural reflow works.
      const onEnd = function(e) {
        if (e.propertyName !== "max-height") return;
        desc.style.maxHeight = "";
        desc.removeEventListener("transitionend", onEnd);
      };
      desc.addEventListener("transitionend", onEnd);
    }
  });
});

// A11y: Owl Carousel renders its nav buttons with no text and role="presentation",
// failing the "buttons have an accessible name" audit. Label them after init.
function fixOwlNavA11y() {
  document.querySelectorAll('button.owl-prev, button.owl-next, button.owl-dot').forEach(function (b) {
    if (!b.getAttribute('aria-label')) {
      var label = b.classList.contains('owl-prev') ? 'Previous slide'
        : b.classList.contains('owl-next') ? 'Next slide' : 'Go to slide';
      b.setAttribute('aria-label', label);
    }
    if (b.getAttribute('role') === 'presentation') b.removeAttribute('role');
  });
}
// Run at several moments AND watch the DOM — Owl creates / re-creates its nav
// buttons at unpredictable times (init, refresh, image load), so a single
// load-time pass can miss them.
document.addEventListener('DOMContentLoaded', fixOwlNavA11y);
window.addEventListener('load', function () {
  fixOwlNavA11y();
  setTimeout(fixOwlNavA11y, 1500);
  setTimeout(fixOwlNavA11y, 4000);
});
(function () {
  if (!('MutationObserver' in window)) return;
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && (n.matches('.owl-nav, .owl-dots, button.owl-prev, button.owl-next, button.owl-dot') || n.querySelector && n.querySelector('button.owl-prev, button.owl-next, button.owl-dot')))) {
          fixOwlNavA11y();
          return;
        }
      }
    }
  });
  var start = function () { mo.observe(document.body, { childList: true, subtree: true }); setTimeout(function () { mo.disconnect(); }, 15000); };
  document.body ? start() : document.addEventListener('DOMContentLoaded', start);
})();
